<template>
  <!--
  default-expand-all:是否默认展开所有节点
  expand-on-click-node="false" :	是否在点击节点的时候展开或者收缩节点， 默认值为 true，如果为 false，则只有点箭头图标的时候才会展开或者收缩节点。
  filterable：是否可搜索
  clearable：是否可清空选项
  empty-values：默认值允许为空或者为0，该属性的默认值是[undefined, null]，由于接口返回的部分字段默认不选择是0，所以配置默认值支持0
  -->
  <el-tree-select
    v-model="inputValue"
    :props="{
      value: 'id',
      label: 'name',
      class: 'belonger-tree-class',
    }"
    :placeholder="props.placeholder"
    :data="state.admin_data"
    default-expand-all
    :expand-on-click-node="false"
    filterable
    clearable
    @change="onChange"
    :empty-values="[null, undefined, 0]"
  >
    <template #default="{ data }">
      <div class="flex gap-x-1 items-center">
        <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
        <el-icon :size="16" v-else><User /></el-icon>
        <li class="flex-1">{{ data.name }}</li>
      </div>
    </template>
  </el-tree-select>
</template>

<script>
import { onMounted, reactive, computed } from "vue";
import { data_getDepartment_tree, data_getAdminDepartment } from "@/http/data";
export default {
  props: {
    value: Object, //值
    placeholder: {
      type: String,
      default: "--请选择--",
    },
    type: {
      //审批角色 (1:业务负责人,2:财务负责人,3:总经理,4:出纳)，json数组
      type: Array,
      default: [],
    },
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      onLoad();
    });

    const inputValue = computed({
      get() {
        return props.value;
      },
      set(val) {
        emit("update:modelValue", val);
      },
    });

    let adminSource = [];

    const onLoad = () => {
      const departmentFunc = new Promise((suc) => {
        data_getDepartment_tree().then((res) => {
          if (res.status == 200) suc(res.data.data);
        });
      });

      const adminFunc = new Promise((suc) => {
        data_getAdminDepartment({
          approver_type: props.type,
        }).then((res) => {
          if (res.status == 200) {
            adminSource = res.data.data;
            suc(adminSource);
          }
        });
      });

      Promise.all([departmentFunc, adminFunc]).then((res) => {
        state.admin_data = build_admin_cascader(res[0], res[1]);
      });
    };

    const build_admin_cascader = (departmentArr, adminArr) => {
      let arr = [];
      departmentArr.forEach((e) => {
        let item = {
          id: "d_" + e.id,
          name: e.name,
          pid: e.pid,
          pname: e.pname,
          type: 0,
          disabled: true,
        };

        item.children = [];
        if (e.children?.length > 0)
          item.children = build_admin_cascader(e.children, adminArr);
        const admins = adminArr
          .filter((w) => w.department_id == e.id)
          .map((m) => {
            return {
              id: m.id,
              name: m.name,
              pid: m.department_id,
              pname: m.department_name,
              type: 1,
            };
          });
        if (admins.length > 0) {
          item.children = [...item.children, ...admins];
        }
        arr.push(item);
      });

      return arr;
    };

    const onChange = (e) => {
      emit(
        "change:item",
        adminSource.find((w) => w.id == e),
      );
    };

    return { state, props, onChange, inputValue };
  },
};
</script>

<style lang="scss" scoped></style>
